const Footer = () => {
  return <div className="footer">© 2016-2022 SALAH AKIL</div>;
};

export default Footer;
